<template>
  <div>
    <div class="card card-outline">
      <div class="card-header mt-2">
        <div class="row">
          <div class="col-md-6 mb-3">
            <div class="input-xs-full-width w-50">
              <label for="input-blindness" class="mb-2">Color blindness filter</label>
              <select @change="gradientAccessibility($event)" v-model="selectedFilter"
                      class="form-select form-control form-big-height"
                      id="input-blindness"
                      aria-label="Select blindness">
                <option value="Normal" selected>Normal</option>
                <option value="Protanopia">Protanopia</option>
                <option value="Protanomaly">Protanomaly</option>
                <option value="Deuteranopia">Deuteranopia</option>
                <option value="Deuteranomaly">Deuteranomaly</option>
                <option value="Tritanopia">Tritanopia</option>
                <option value="Tritanomaly">Tritanomaly</option>
                <option value="Achromatopsia">Achromatopsia</option>
                <option value="Achromatomaly">Achromatomaly</option>
              </select>
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <div class="input-xs-full-width w-100">
              <label for="input-text-preview" class="mb-2">Text (Toggle dark mode to preview the text in black or
                white)</label>
              <input v-model="textComponent" id="input-text-preview" class="form-control form-big-height"
                     placeholder="Edit me!">
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <section class="" id="sectionFilter">
          <div class="card shadow-0dp py-3" v-if="gradient.color3"
               :style="{ 'background': 'linear-gradient' + '(to right,' + gradient.color1 + ',' + gradient.color2 + ',' + gradient.color3 + ')' }">
            <div class="card-body">
              <p class="typography-headline-sm mb-0">{{ textComponent }}</p>
            </div>
          </div>
          <div class="card shadow-0dp py-3" v-else
               :style="{ 'background': 'linear-gradient' + '(to right,' + gradient.color1 + ',' + gradient.color2 + ')' }">
            <div class="card-body">
              <p class="typography-headline-sm mb-0">{{ textComponent }}</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'gradient'
  ],
  data() {
    return {
      selectedFilter: 'Normal',
      textComponent: 'Your text content here',
    }
  },
  methods: {
    gradientAccessibility() {
      const filter = this.selectedFilter
      if (filter === 'Normal') {
        document.getElementById('sectionFilter').className = ''
      }
      if (filter === 'Protanopia') {
        document.getElementById('sectionFilter').className = ''
        document.getElementById('sectionFilter').classList.toggle('protanopia')
      }
      if (filter === 'Protanomaly') {
        document.getElementById('sectionFilter').className = ''
        document.getElementById('sectionFilter').classList.toggle('protanomaly')
      }
      if (filter === 'Deuteranopia') {
        document.getElementById('sectionFilter').className = ''
        document.getElementById('sectionFilter').classList.toggle('deuteranopia')
      }
      if (filter === 'Deuteranomaly') {
        document.getElementById('sectionFilter').className = ''
        document.getElementById('sectionFilter').classList.toggle('deuteranomaly')
      }
      if (filter === 'Tritanopia') {
        document.getElementById('sectionFilter').className = ''
        document.getElementById('sectionFilter').classList.toggle('tritanopia')
      }
      if (filter === 'Tritanomaly') {
        document.getElementById('sectionFilter').className = ''
        document.getElementById('sectionFilter').classList.toggle('tritanomaly')
      }
      if (filter === 'Achromatopsia') {
        document.getElementById('sectionFilter').className = ''
        document.getElementById('sectionFilter').classList.toggle('achromatopsia')
      }
      if (filter === 'Achromatomaly') {
        document.getElementById('sectionFilter').className = ''
        document.getElementById('sectionFilter').classList.toggle('achromatomaly')
      }
    }
  }
}
</script>